import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import * as firebase from 'firebase';
import { AlertService } from '../../../_services/alert.service';
import { v4 as uuidv4 } from 'uuid';
import * as faker from 'faker';
import * as moment from 'moment';
import * as _ from 'underscore';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-meetings-activity',
  templateUrl: './meetings-activity.component.html',
  styleUrls: ['./meetings-activity.component.css']
})
export class MeetingsActivityComponent implements OnInit {
  modalRef: any;
  iconTab: FormGroup;
  meals = ['Yes', 'No'];
  members = ['Walter White', 'Jessy Pinkman', 'Heisenberg', 'Skylar White', 'Saul Goodman']
  modes = ['Bus', 'Train']
  mealTypes = ['Personal', 'Client', 'Team']
  mealSession = ['Breakfast', 'Lunch', 'Dinner', 'Others']

  private activityList: Array<any> = [];
  tagList = [];
  isLoading: any = false;
  isUploading: any = false;
  snapList: any = [];
  diffList = [];
  selectedItems = [];
  dropdownSettings = {};
  keyIndex: any = -1;
  minDate: any;
  maxDate: any;
  startDate: any;
  currMinDate: any;
  currMaxDate: any;
  meetingStart: any;
  meetingEnd: any;
  addedBy: any;
  verifyFields = [
    {
      "key": "meetingPurpose",
      "value": "MeetingPurpose"
    },
    {
      "key": "meetingStartDate",
      "value": "MeetingStartDate",
      "isDate": true
    },
    {
      "key": "meetingEndDate",
      "value": "MeetingEndDate",
      "isDate": true
    },
    {
      "key": "meetLocation",
      "value": "MeetLocation"
    },
    {
      "key": "startTimeMeet",
      "value": "StartTimeMeet"
    },
    {
      "key": "endTimeMeet",
      "value": "EndTimeMeet"
    },
    {
      "key": "otherInfoMeet",
      "value": "OtherInfoMeet"
    },
    {
      "key": "transNumberMeet",
      "value": "TransNumberMeet"
    },
    {
      "key": "merchNameMeet",
      "value": "MerchNameMeet"
    }
  ]


  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };
  }

  @Input() data: any;
  @Input() travellers: any;
  @Input() createdBy: any;
  @Input() code: any;
  @Input() isDisabled: any;
  @Input() isReadOnly: any;
  @Input() isActivityEdit: any;
  // @Input() diffList: any;
  @Output() flightData: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.iconTab = this.formBuilder.group({
      activityDetails: [[]],

      // Meet Activity
      meetingStartDate: ['', Validators.required],
      meetingEndDate: ['', Validators.required],
      meetingStart: ['', Validators.required],
      meetingEnd: ['', Validators.required],
      meetingPurpose: ['', Validators.required],
      meetLocation: ['', Validators.required],
      startTimeMeet: ['', Validators.required],
      endTimeMeet: ['', Validators.required],
      tagMembersMeet: ['', Validators.required],
      otherInfoMeet: ['', Validators.required],
      transNumberMeet: ['', Validators.required],
      merchNameMeet: ['', Validators.required],
      createdBy: ['', Validators.required],

    });
    this.tagList = this.travellers;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    console.log('****** data ', this.data);
    if (this.data && this.data.basicDetails) {
      this.iconTab.patchValue({
        category: this.data.basicDetails ?.category,
        meetingPurpose: this.data.basicDetails.purpose,
        meetingStart: this.stringToObjDate(this.data.basicDetails ?.date),
        meetingEnd: this.stringToObjDate(this.data.basicDetails ?.endDate),
        tagMembersMeet: this.data.basicDetails ?.tagMembers || [],
        createdBy: this.data.invoiceDetails.uploadedBy,
        transNumberMeet: this.data.invoiceDetails.invoiceNumber,
        merchNameMeet: this.data.invoiceDetails.vendorName,
      })
      this.createdBy = this.data.invoiceDetails.uploadedBy;
      this.selectedItems = this.data.basicDetails.tagMembers || [];
    } else {
      this.iconTab.patchValue(this.data);
      this.selectedItems = this.data ? this.data.tagMembersMeet : '' || [];
      this.createdBy = this.data ? this.data.createdBy : this.createdBy + " - " + this.code;
    }
    this.addedBy = this.data ? this.data.createdBy : this.createdBy;
    this.snapList = this.data ? this.data.snapList : '' || [];
    this.diffList = this.data && this.data.activityDiffList || [];
    console.log('data', this.data, this.diffList, this.code)
  }


  stringToObjDate(strVal: any) {
    let res = strVal
    if (_.isObject(strVal)) {
      return res
    } else {
      res = {
        year: (+moment(strVal, 'YYYY-MM-DD').format('YYYY')),
        month: (+moment(strVal, 'YYYY-MM-DD').format('MM')),
        day: (+moment(strVal, 'YYYY-MM-DD').format('DD'))
      };
    }
    return res;
  }


  meetingActivity() {
    this.activityList.push({
      category: "Meeting",
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      meetingPurpose: this.iconTab.value.meetingPurpose,
      meetLocation: this.iconTab.value.meetLocation,
      startTimeMeet: this.iconTab.value.startTimeMeet,
      endTimeMeet: this.iconTab.value.endTimeMeet,
      tagMembersMeet: this.iconTab.value.tagMembersMeet,
      otherInfoMeet: this.iconTab.value.otherInfoMeet,
      transNumberMeet: this.iconTab.value.transNumberMeet,
      merchNameMeet: this.iconTab.value.merchNameMeet,
    })
    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: "Meeting",
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      meetingPurpose: '',
      meetLocation: '',
      startTimeMeet: '',
      endTimeMeet: '',
      tagMembersMeet: '',
      otherInfoMeet: '',
      transNumberMeet: '',
      merchNameMeet: '',
    })
  }
  get f() {
    return this.iconTab.controls;
  }

  editMeetActivity(index, content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'animated fadeInDown', size: 'lg' });
    this.keyIndex = index;
    this.iconTab.patchValue({
      meetingStartDate: this.activityList[index].meetingStartDate,
      meetingEndDate: this.activityList[index].meetingEndDate,
      meetingStart: this.activityList[index].meetingStart,
      meetingEnd: this.activityList[index].meetingEnd,
      meetingPurpose: this.activityList[index].meetingPurpose,
      meetLocation: this.activityList[index].meetLocation,
      startTimeMeet: this.activityList[index].startTimeMeet,
      endTimeMeet: this.activityList[index].endTimeMeet,
      tagMembersMeet: this.activityList[index].tagMembersMeet,
      otherInfoMeet: this.activityList[index].otherInfoMeet,
      transNumberMeet: this.activityList[index].transNumberMeet,
      merchNameMeet: this.activityList[index].merchNameMeet,
    });
    this.selectedItems = this.activityList[index].tagMembersMeet
  }

  getDiffItem(key: any, val: any) {
    let d = _.groupBy(this.diffList, 'key')[key]
    if (d && d.length) {
      return d[0][val]
    }
  }

  displayMembers(allMembers: any) {
    console.log(allMembers);
    allMembers = allMembers.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ',  ');
    return allMembers;
  }

  upDateMeetActivity() {
    this.activityList[this.keyIndex] = {
      category: 'Meeting',
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      meetingPurpose: this.iconTab.value.meetingPurpose,
      meetLocation: this.iconTab.value.meetLocation,
      startTimeMeet: this.iconTab.value.startTimeMeet,
      endTimeMeet: this.iconTab.value.endTimeMeet,
      tagMembersMeet: this.iconTab.value.tagMembersMeet || '',
      otherInfoMeet: this.iconTab.value.otherInfoMeet,
      transNumberMeet: this.iconTab.value.transNumberMeet || '',
      merchNameMeet: this.iconTab.value.merchNameMeet,
    };

    this.iconTab.patchValue({
      activityDetails: this.activityList,
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      meetingPurpose: '',
      meetLocation: '',
      startTimeMeet: '',
      endTimeMeet: '',
      tagMembersMeet: '',
      otherInfoMeet: '',
      transNumberMeet: '',
      merchNameMeet: '',
    });
    this.keyIndex = -1;
  }

  selectMeetingStartDate(event) {
    console.log(event);
    this.startDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingStartDate: finalDate
    })
    this["meetingStart"] = finalDate;
  }

  selectMeetingEndDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingEndDate: finalDate
    })
    this["meetingEnd"] = finalDate;
  }

  getMinDate() {
    if (this.startDate) {
      return (this.startDate)
    } else {
      return this.minDate
    }
  }

  dumpData() {

    let fakeData = {
      meetingPurpose: faker.lorem.word(),
      meetLocation: faker.lorem.word(),
      otherInfoMeet: faker.lorem.word(),
      transNumberMeet: 'MEET021455',
      merchNameMeet: faker.lorem.word(),
      meetingStart: moment().add(5, 'days').format('DD-MM-YYYY'),
      meetingEnd: moment().add(10, 'days').format('DD-MM-YYYY'),
      startTimeMeet: {
        hour: 10,
        minute: 0,

      },
      endTimeMeet: {
        hour: 18,
        minute: 0,

      }
    }

    this.meetingStart = {
      day: +moment(moment().add(5, 'days').format('YYYY-MM-DD')).format('DD'),
      month: +moment(moment().add(5, 'days').format('YYYY-MM-DD')).format('MM'),
      year: +moment(moment().add(5, 'days').format('YYYY-MM-DD')).format('YYYY')
    };
    this.meetingEnd = {
      day: +moment(moment().add(10, 'days').format('YYYY-MM-DD')).format('DD'),
      month: +moment(moment().add(10, 'days').format('YYYY-MM-DD')).format('MM'),
      year: +moment(moment().add(10, 'days').format('YYYY-MM-DD')).format('YYYY')
    };


    this.iconTab.patchValue({
      ...fakeData,
    })
    console.log('*** fakeData *** ', fakeData);
  }

  readableDateFormat(userDate: any) {
    if (!_.isObject(userDate)) {
      return userDate;
    } else {
      let year = userDate.year;
      let month = userDate.month <= 9 ? '0' + userDate.month : userDate.month;;
      let day = userDate.day <= 9 ? '0' + userDate.day : userDate.day;;
      let finalDate = day + "-" + month + "-" + year;
      return finalDate;
    }
  }

  addNewItem() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Save?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        if (!this.iconTab.value.meetingPurpose || !this.iconTab.value.meetLocation || !this.iconTab.value.meetingStart
          || !this.iconTab.value.startTimeMeet || !this.iconTab.value.meetingEnd || !this.iconTab.value.endTimeMeet
          || !this.iconTab.value.otherInfoMeet) {
          this.alertService.showError('Mandatory fields to be filled !');
          return false;
        }

        let isMatch = _.isMatch(this.data, this.iconTab.value);
        if (isMatch && this.isActivityEdit) {
          this.alertService.showError('No Changes made to amend !', 3000, 'Invalid update !')
          return false;
        }

        let activityDiffList = [];
        if (!isMatch && this.isActivityEdit) {
          let that = this;
          let old = _.clone(this.data), fresh = _.clone(this.iconTab.value);
          _.each(this.verifyFields, function(field) {
            let newVal = fresh[field.key], oldVal = old[field.key];
            if (old[field.key] != fresh[field.key]) {

              // if (field.key == 'meals' && newVal == 'No') {
              //   newVal = fresh['meals']
              // } else {
              //   newVal = fresh['meals']
              // }

              activityDiffList.push({
                key: field.key,
                name: field.value,
                oldVal: field.isDate ? that.readableDateFormat(old[field.key]) : oldVal,
                newVal: field.isDate ? that.readableDateFormat(fresh[field.key]) : newVal
              })
            }
          })
        }

        console.log('am in addNewItem ', activityDiffList, this.activityList, this.iconTab.value);
        this.flightData.emit({ ...this.iconTab.value, activityDiffList: activityDiffList, snapList: this.snapList, category: 'Meeting', uniqueId: uuidv4(), addedBy: this.addedBy, key: this.code });
        this.closeModal();
      }
    })
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  chooseFile() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Upload Confirmation Doc?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        document.getElementById("avatar").click();
      }
    })
  }

  upload() {
    // Create a root reference
    let storageRef = firebase.storage().ref();
    this.isUploading = true;
    let that = this;

    for (let selectedFile of [(<HTMLInputElement>document.getElementById('avatar')).files[0]]) {
      // let path = '/BILLS/' + Date.now() + `${selectedFile.name}`;
      let path = '/BILLS/' + Date.now() + '_' + `${selectedFile.name}`;
      let iRef = storageRef.child(path);
      iRef.put(selectedFile).then((snapshot) => {
        snapshot.ref.getDownloadURL()
          .then((url) => {
            let images = that.snapList || [];
            images.push(url);
            that.snapList = images;
            this.isUploading = false;
          })
      });
    }
  }

  removeImage(index: any) {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Remove?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.snapList.splice(index, 1);
      }
    })
  }

  getFileName(url: any) {
    let data = '';
    if (url.split('_')[1]) {
      data = url.split('_')[1].split('?');
      data = data[0] ? decodeURI(data[0]) : '';
      return data;
    } else {
      return data;
    }
  }

}
